import React, { memo, useMemo, useState } from "react";

type ResultStatsContextProps = {
  displayedResults: number | null;
  numberOfResults: number | null;
  setDisplayedResults: React.Dispatch<React.SetStateAction<number | null>>;
  setNumberOfResults: React.Dispatch<React.SetStateAction<number | null>>;
};

export const ResultStatsContext = React.createContext<ResultStatsContextProps>({
  displayedResults: 0,
  numberOfResults: 0,
  setDisplayedResults: () => {},
  setNumberOfResults: () => {},
});

export const ResultStatsProvider: React.FC = memo(({ children }) => {
  const [displayedResults, setDisplayedResults] = useState<number | null>(null);
  const [numberOfResults, setNumberOfResults] = useState<number | null>(null);

  const value = useMemo(
    () => ({
      displayedResults,
      numberOfResults,
      setDisplayedResults,
      setNumberOfResults,
    }),
    [displayedResults, numberOfResults]
  );

  return <ResultStatsContext.Provider value={value}>{children}</ResultStatsContext.Provider>;
});

ResultStatsProvider.displayName = "ResultStatsProvider";
